import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../store/store";
import { QuickFilter, setQuickFilter } from "../store/slices/filters.slice";
import { cleanUpFeedPage } from "../store/slices/feed.slice";

const useFeed = () => {
  const dispatch = useAppDispatch();
  const quickFilter: QuickFilter = useAppSelector((state: any) => state.filters.quickFilter);

  const selectQuickFilter = useCallback(
    (filter: QuickFilter) => {
      if (filter === quickFilter) return;
      dispatch(setQuickFilter(filter));
      dispatch(cleanUpFeedPage());
    },
    [dispatch, quickFilter]
  );

  const onGenresApplied = useCallback(
    (genres: number[]) => {
      if (genres.length > 0 && (quickFilter === "all" || quickFilter === "for_you")) {
        dispatch(setQuickFilter("popular"));
      }
    },
    [dispatch, quickFilter]
  );

  return { quickFilter, selectQuickFilter, onGenresApplied };
};

export default useFeed;
